<!--
 * @Author: 谢树和 shuhe.xie@southgis.com
 * @Date: 2022-10-17 15:43:29
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @LastEditTime: 2022-11-04 17:45:19
 * @FilePath: \standard-v5\src\views\OpinionPublish\OpinionPublishDetail.vue
 * @Description: 意向发布 - 意向详情
-->

<template>
  <div class="confirm">
    <div class="top">
      <div class="title">
        {{ data.GCMC }}
        <div class="state">
          <van-tag plain type="primary" size="medium">{{ data.ZT }}</van-tag>
        </div>
      </div>
      <div class="desc">
        <div>意向浏览次数：{{ data.LLCS }}</div>
        <div>发布时间：{{ data.CJSJ }}</div>
      </div>
    </div>
    <div class="sub-title">项目信息</div>
    <div class="info">
      <div class="item">
        <div class="label">项目代码</div>
        <div class="text">{{ data.GCBH }}</div>
      </div>
      <div class="item">
        <div class="label">项目地点</div>
        <div class="text">{{ data.XZQ + data.GCXXDD }}</div>
      </div>
      <div class="item">
        <div class="label">项目性质</div>
        <div class="text">{{ data.JSXZ }}</div>
      </div>
      <div class="item">
        <div class="label">土地来源</div>
        <div class="text">{{ data.TDLY }}</div>
      </div>
      <div class="item">
        <div class="label">建筑面积</div>
        <div class="text">{{ data.JZMJ }}</div>
      </div>
      <div class="item">
        <div class="label">建设单位</div>
        <div class="text">{{ data.WTDW }}</div>
      </div>
      <div class="item">
        <div class="label">测绘事项</div>
        <div class="text">{{ CLSXvalue }}</div>
      </div>
      <div class="item">
        <div class="label">发布对象</div>
        <div class="text" v-html="data.FBDX">
          <!-- {{ data.FBDX }} -->
          <!-- 广东省南方数码股份有限公司<br/>
          广东省南方智能股份有限公司<br/>
          广州市华和测绘单位<br/>
          瑞册有限公司 -->
        </div>
      </div>
      <div class="item">
        <div class="label">有效时间</div>
        <div class="text">{{ data.YXYXQKSSJ + '至' + data.YXYXQJSSJ }}</div>
      </div>
      <div class="item">
        <div class="label">接单口令</div>
        <div class="text">{{ data.JDKL }}</div>
      </div>
    </div>
    <div class="sub-title">基本信息</div>
    <div class="info" style="margin-bottom: 40px">
      <div class="item">
        <div class="label">联系人</div>
        <div class="text">{{ data.LXR || '-' }}</div>
      </div>
      <div class="item">
        <div class="label">联系电话</div>
        <div class="text">{{ data.LXDH || '-' }}</div>
      </div>
      <div class="item">
        <div class="label">电子邮箱</div>
        <div class="text">{{ data.DZYX || '-' }}</div>
      </div>
    </div>
    <div class="btn-detail" v-if="data.ZT=='暂存'">
      <van-button type="danger" class="btn" @click="deletOpinion">删除意向</van-button>
      <van-button type="info" class="btn" @click="goonOpinion">继续发布</van-button>
    </div>
    <div class="btn-detail" v-if="data.ZT=='发布中'">
      <van-button block type="info" @click="stopOpinion">终止意向</van-button>
    </div>
    <!-- <div class="btn-detail">
      <van-button block type="info" @click="toHome">返回列表</van-button>
    </div> -->
  </div>
</template>

<script>
import api from '@/utils/api/opinionPublish'
import moduleMixins from '@/mixins/moduleMixins'
import { mapMutations } from 'vuex'
export default {
  components: {},
  mixins: [ moduleMixins ],
  props: {},
  data() {
    return {
      data: {},
      CLSXvalue: ''
    };
  },
  watch: {},
  computed: {
    navTitle() {
      return '意向详情'
    },
  },
  methods: {
    ...mapMutations('opinion', ['setOpinionData', 'setRid']),
    deletOpinion() {
      this.$dialog.confirm({
        title: '—— 温馨提示 ——',
        message: '是否删除当前意向？',
        confirmButtonColor: '#1D84FF'
      }).then(() => {
        api.deleteIntention({
          rid: this.data.RID
        }).then(res => {
          if(res.code== 0) {
            this.$toast('意向已删除')
            setTimeout(() => {
              this.$router.go(-1)
            }, 1500)
          } else {
            this.$toast(res.message)
          }
        })
      })
    },
    goonOpinion() {
      // 获取意向发布接口，获取配置数据
      api.getIntentionConfig().then(res => {
        let allData = res.data
        // 继续发布接口，获取暂存数据
        api.continueIntention({
          rid: this.data.RID
        }).then(res => {
          let storageData = JSON.parse(res.data)
          allData.forEach((item, i) => {
            if(i <= storageData[7].current) item.data = storageData[i]
          })

          let name = ''
          if(storageData[7].current == 3) {
            name = 'OpinionPublishOrgan'
          } else if(storageData[7].current == 2) {
            name = 'OpinionPublishStage'
          } else {
            name = 'OpinionPublishProject'
          }
          this.setOpinionData(allData)
          // console.log(allData)

          this.setRid(this.data.RID)
          this.$router.push({
            name
          })

          // let name = ''
          // if(allData[3].data.length > 0) {
          //   name = 'OpinionPublishOrgan'
          // } else if(allData[2].data.CLSX.length > 0) {
          //   name = 'OpinionPublishStage'
          // } else {
          //   name = 'OpinionPublishProject'
          // }
          // this.setRid(this.data.RID)
          // this.$router.push({
          //   name,
          //   params: {}
          // })
        })
      })
    },
    stopOpinion() {
      this.$dialog.confirm({
        title: '—— 温馨提示 ——',
        message: '是否确定终止当前意向？',
        confirmButtonColor: '#1D84FF'
      }).then(() => {
        api.cancelIntention({
          rid: this.data.RID
        }).then(res => {
          if(res.code== 0) {
            this.$toast('意向已终止')
            setTimeout(() => {
              this.$router.go(-1)
            }, 1500)
          } else {
            this.$toast(res.message)
          }
        })
      })
    },
    toHome() {
      if(this.$route.query.from == 'confirm') {
        this.$router.go(-6)
      } else {
        // this.$router.go(-1)
        this.$router.replace({
          name: 'OpinionPublishHome'
        })
      }
    },
    getClsxValue() {
      api.getClsxValue({
        key: this.data.CLSX
      }).then(res => {
        // console.log(res)
        this.CLSXvalue = res.data
      })
    },
    getIntention(rid) {
      api.getIntention({ rid }).then(res => {
        this.data = res.data.rowsList[0]
        this.data.FBDX = this.data.FBDX.replace(/;/g, '<br />')
        this.getClsxValue()
      })
    }
  },
  created() {
    this.getIntention(this.$route.query.rid)
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.confirm {
  padding-bottom: 50px;
  .top {
    background-color: #fff;
    .title {
      padding: 20px 15px;
      color: #1D84FF;
      position: relative;
      .state {
        position: absolute;
        right: 15px;
        top: 22px;
      }
    }
    .desc {
      font-size: 14px;
      color: #666;
      padding: 0px 15px 20px;
      display: flex;
      justify-content: space-between;
    }
  }
  .sub-title {
    padding: 15px;
    color: #333;
  }
  .info {
    background-color: #fff;
    .item {
      padding: 15px 0;
      margin: 0 15px;
      font-size: 14px;
      border-bottom: 1px solid #dfdfdf;
      display: flex;
      justify-content: space-between;
      // align-items: center;
      &:last-child {
        border-bottom: 0;
      }
      .label {
        width: 110px;
        color: #666;
        margin-right: 20px;
      }
      .text {
        color: #333;
        text-align: right;
      }
    }
  }

  .btn-detail {
    padding: 0 20px;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    .btn {
      width: 45%;
    }
  }
  // .btn-group {
  //   width: 100%;
  //   padding: 10px 0;
  //   text-align: center;
  //   background-color: #fff;
  //   position: fixed;
  //   bottom: 0;
  //   display: flex;
  //   justify-content: space-around;
  // }
  .success-dialog {
    text-align: center;
    padding: 30px 0;
    img {
      width: 60px;
    }
    .text {
      font-size: large;
      font-weight: bold;
      padding-top: 10px;
    }
  }
}
</style>